<template>
  <v-select 
    label="Parcel Number Container"  
    :items="parcelnumbercontainers" 
    item-value="id"
    v-model="dirtyParcelNumberContainerId" 
    @change="saveParcelNumberContainer()"
  >
    <template slot="selection" slot-scope="data">
      <v-chip>{{getChipString(data.item)}}</v-chip> <span>{{data.item.name}}</span>
    </template>
    <template slot="item" slot-scope="data">
      <v-chip>{{getChipString(data.item)}}</v-chip> {{data.item.name}}
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    parcelnumbercontainers: {
      type: Array,
      required: true
    },
    parcelNumberContainerId: {
      type: Number
    }
  },

  data() {
    return {
      dirtyParcelNumberContainerId: this.parcelNumberContainerId
    }
  },

  methods: {
    saveParcelNumberContainer() {
      this.$emit('change', this.dirtyParcelNumberContainerId)
    },

    getChipString(parcelnumbercontainer) {
      let str = ""
      switch(parcelnumbercontainer.containerType) {
          case 'OWNER': 
            str = `Owner ${parcelnumbercontainer.ownerId}`
            break
          case 'LOCATION': 
            str = `Location ${parcelnumbercontainer.locationId}`
            break
          case 'CUSTOMER': 
            str = `Customer ${parcelnumbercontainer.customerId}`
            break
        }
        return str
    }
  }
}
</script>


// WEBPACK FOOTER //
// IsrsParcelNumberSelect.vue?10f933da